(() => {
  const sticky = document.querySelector("[data-me-sticky]");
  const purchase = document.querySelector("[data-me-purchase]");
  const syncSticky = () => {
    if (!sticky || !purchase) return;
    const passed = purchase.getBoundingClientRect().top < 0;
    sticky.classList.toggle("is-visible", passed);
    sticky.setAttribute("aria-hidden", passed ? "false" : "true");
  };
  if (sticky && purchase) {
    syncSticky();
    window.addEventListener("scroll", syncSticky, { passive: true });
    window.addEventListener("resize", syncSticky);
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(syncSticky, { threshold: [0, 0.01, 0.15, 1] });
      io.observe(purchase);
    }
  }
  document.querySelectorAll('a[href="#me-purchase"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const target = document.querySelector("#me-purchase, [data-me-purchase]");
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      try {
        history.replaceState({}, "", "#me-purchase");
      } catch (_) {}
    });
  });

  const stickyAdd = document.querySelector("[data-me-sticky-add]");
  if (stickyAdd && purchase) {
    stickyAdd.addEventListener("click", () => {
      const add = purchase.querySelector('button[name="add"], button[type="submit"]');
      if (add) add.click();
    });
  }

  document.querySelectorAll("[data-me-craft]").forEach((root) => {
    const chapters = Array.from(root.querySelectorAll("[data-me-craft-chapter]"));
    if (chapters.length < 2) return;
    const dots = Array.from(root.querySelectorAll("[data-me-craft-dot]"));
    let index = 0;
    const show = (next) => {
      index = (next + chapters.length) % chapters.length;
      chapters.forEach((chapter, n) => {
        const on = n === index;
        chapter.classList.toggle("is-active", on);
        if (on) chapter.removeAttribute("hidden");
        else chapter.setAttribute("hidden", "");
      });
      dots.forEach((dot, n) => {
        const on = n === index;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-selected", on ? "true" : "false");
      });
    };
    dots.forEach((dot) => {
      dot.addEventListener("click", () => show(Number(dot.dataset.meCraftDot || 0)));
    });
    const prev = root.querySelector("[data-me-craft-prev]");
    const next = root.querySelector("[data-me-craft-next]");
    if (prev) prev.addEventListener("click", () => show(index - 1));
    if (next) next.addEventListener("click", () => show(index + 1));
  });

  const formatMoney = (cents, format) => {
    const amount = (Number(cents) / 100).toFixed(2);
    const whole = String(Math.round(Number(cents) / 100));
    const fmt = format || "{{amount}}";
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  };

  document.querySelectorAll("[data-me-purchase]").forEach((root) => {
    let variants = [];
    try {
      variants = JSON.parse(root.getAttribute("data-variants") || "[]");
    } catch (_) {
      variants = [];
    }
    const moneyFormat = root.getAttribute("data-money-format") || "";
    const form = root.querySelector("[data-me-product-form]") || root.querySelector("form.me-form");
    const idInput = root.querySelector("[data-me-variant-id]");
    const priceEl = root.querySelector("[data-me-price]");
    const addBtn = root.querySelector("[data-me-add]");
    const optionInputs = () => Array.from(root.querySelectorAll("[data-me-option]"));

    const selectedOptions = () => {
      const values = [];
      optionInputs().forEach((input) => {
        if (!input.checked) return;
        const idx = Number(input.getAttribute("data-option-index") || 0);
        values[idx] = input.value;
      });
      return values;
    };

    const findVariant = () => {
      const selected = selectedOptions();
      if (!variants.length) return null;
      return (
        variants.find((v) => {
          const opts = v.options || [v.option1, v.option2, v.option3].filter((x) => x != null);
          return selected.every((val, i) => !val || opts[i] === val);
        }) || null
      );
    };

    const syncOptionChrome = () => {
      root.querySelectorAll(".me-sw").forEach((sw) => {
        const input = sw.querySelector("input");
        sw.classList.toggle("is-selected", !!(input && input.checked));
      });
      root.querySelectorAll(".me-pill").forEach((pill) => {
        const input = pill.querySelector("input");
        pill.classList.toggle("is-on", !!(input && input.checked));
      });
      root.querySelectorAll("[data-me-option-label]").forEach((label) => {
        const idx = label.getAttribute("data-option-index");
        const checked = root.querySelector(
          `[data-me-option][data-option-index="${idx}"]:checked`
        );
        const name =
          (checked && checked.getAttribute("data-option-name")) ||
          label.getAttribute("data-option-name") ||
          "";
        const value = checked ? checked.value : "";
        label.textContent = value ? `${name} - ${value}` : name;
      });
    };

    const syncVariant = () => {
      syncOptionChrome();
      const variant = findVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        const cents = variant.price != null ? variant.price : variant.price_cents;
        if (cents != null) priceEl.textContent = formatMoney(cents, moneyFormat);
      }
      const img = root.querySelector(`.me-vimg[data-vid="${variant.id}"]`);
      if (img) {
        root.querySelectorAll(".me-vimg").forEach((node) => node.classList.remove("is-active"));
        img.classList.add("is-active");
      }
      if (addBtn) {
        const available = variant.available !== false;
        addBtn.disabled = !available;
        addBtn.setAttribute("aria-disabled", available ? "false" : "true");
        const labelAdd = addBtn.getAttribute("data-label-add") || "Add to bag";
        const labelSold = addBtn.getAttribute("data-label-sold") || "Sold out";
        addBtn.textContent = available ? labelAdd : labelSold;
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", String(variant.id));
        window.history.replaceState({}, "", url.toString());
      } catch (_) {}
    };

    optionInputs().forEach((input) => {
      input.addEventListener("change", syncVariant);
    });

    root.querySelectorAll("[data-me-qty-btn]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const input = root.querySelector("[data-me-qty]");
        if (!input) return;
        const delta = Number(btn.getAttribute("data-me-qty-btn") || 0);
        const next = Math.max(1, (Number(input.value) || 1) + delta);
        input.value = String(next);
      });
    });

    syncVariant();
  });

  const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll("[data-me-screen] video").forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.removeAttribute("controls");
    const tfLazy = video.hasAttribute("data-tf-lazy");
    if (!tfLazy) video.setAttribute("autoplay", "");
    video.setAttribute("muted", "");
    video.setAttribute("loop", "");
    video.setAttribute("playsinline", "");
    if (reduceMotion) {
      video.pause();
      return;
    }
    const tryPlay = () => {
      const play = video.play();
      if (play && typeof play.catch === "function") play.catch(() => {});
    };
    if (!tfLazy) tryPlay();
    video.addEventListener("click", () => {
      if (video.paused) tryPlay();
      else video.pause();
    });
  });
})();
